import {Link, useNavigate} from 'react-router-dom'

type Props = {
  className: string
  title: string
  description: string
  numberPrincipal: number | string
  link?: string
  label1: string
  numberLabel1: number | string
  label2: string
  numberLabel2: number | string
}

const CardsWidgetTiles = ({
  className,
  title,
  description,
  numberPrincipal,
  link,
  label1,
  numberLabel1,
  label2,
  numberLabel2,
}: Props) => {
  const navigate = useNavigate()

  const handleLink = () => {
    setTimeout(() => {
      if (link) {
        navigate(link)
      }
    }, 100)
  }

  return (
    <div className={`card ${className}  ${link ? 'cursor-pointer' : ''}`} onClick={handleLink}>
      <div className='d-flex flex-column  ' style={{height: '100%'}}>
        <div className='d-flex flex-column  align-items-center justify-content-center mt-3 mb-15'>
          <span className='fw-bolder text-dark pt-1 fs-1 text-center text-uppercase'>{title}</span>

          <span className='fw-bold text-dark me-2 lh-1 ls-n2' style={{fontSize: '80px'}}>
            {typeof numberPrincipal === 'number' ? (
              numberPrincipal
            ) : (
              <span
                className='spinner-border spinner-border-lg align-middle ms-2'
                style={{borderWidth: '3px'}}
              ></span>
            )}
          </span>

          <span className='text-gray-700 pt-1 fw-semibold fs-1 text-center '>{description}</span>
        </div>

        <div className='d-flex flex-column align-items-end px-8 mx-8'>
          <span className='text-success fs-2 text-end' style={{marginBottom: '-5px'}}>
            {`${label1}: `}
            {typeof numberLabel1 === 'number' ? (
              numberLabel1
            ) : (
              <span
                className='spinner-border align-middle'
                style={{
                  borderWidth: '2px',
                  width: '15px', // Ajusta el tamaño del spinner
                  height: '15px', // Ajusta el tamaño del spinner
                  marginLeft: '3px',
                }}
              ></span>
            )}
          </span>
          <span className='text-success fs-2 text-end' style={{marginTop: '-5px'}}>
            {`${label2}: `}
            {typeof numberLabel2 === 'number' ? (
              numberLabel2
            ) : (
              <span
                className='spinner-border align-middle'
                style={{
                  borderWidth: '2px',
                  width: '15px', // Ajusta el tamaño del spinner
                  height: '15px', // Ajusta el tamaño del spinner
                  marginLeft: '3px',
                }}
              ></span>
            )}
          </span>
        </div>
      </div>
    </div>
  )
}

export {CardsWidgetTiles}
